import React, { useContext, useEffect } from "react"
import "twin.macro"
import { QuestionProps } from "../../../pages/q/[id]"
import { Button } from "../../formElements/button"
import { Routes } from "../../../routes"
import { useTranslation } from "next-i18next"
import { Container } from "../../page/gridContainer"
import Link from "next/link"
import { useRouter } from "next/router"
import { Events, registerEvent } from "../../../analytics"
import { QuestionCard } from "../../questionCard"
import { AuthContext } from "../../../utils/context"

export const QuestionExpired = (props: QuestionProps) => {
  const { t } = useTranslation("question")
  const router = useRouter()
  const { question } = props
  const { Artist } = question
  const { userId } = useContext(AuthContext)

  const isArtist = userId === Artist.id

  useEffect(() => {
    registerEvent(Events.VisitedExpiredQuestion)
  }, [])

  const backToProfile = async () => {
    await router.push({ pathname: Routes.Profile, query: { username: Artist.username } })
  }

  const expiredNote = isArtist ? t("expired.note", { Name: "You" }) : t("expired.note", { Name: Artist.name })

  return (
    <section tw="py-8 mb-12 h-full">
      <Container>
        <div tw="grid grid-cols-4 tablet:grid-cols-12 gap-4 desktop:gap-6 gap-y-4">
          <div tw="col-span-4 space-y-8 tablet:(col-span-8 col-start-3) tablet-lg:(col-span-8 col-start-3)">
            <h1 tw="py-2 text-xl font-bold text-center">
              {t("open.title")}
              <Link href={{ pathname: Routes.Profile, query: { username: Artist.username } }} passHref>
                <a data-testid="artist-profile-link" tw="block tablet:(inline)">
                  {Artist.name}
                </a>
              </Link>
            </h1>
          </div>

          <div tw="col-span-4 tablet:(col-span-8 col-start-3) tablet-lg:(col-span-8 col-start-3 space-y-6)">
            <QuestionCard {...props} linked={false} />
          </div>

          <div tw="col-span-4 tablet:(col-span-8 col-start-3) tablet-lg:(col-span-8 col-start-3 space-y-6)">
            <div tw="w-full flex flex-col items-center justify-between space-y-3 tablet:(flex-row space-x-6 space-y-0)">
              <div>
                <p tw="text-lg font-bold">{t("expired.title")}</p>
                <p>{expiredNote}</p>
              </div>

              {!isArtist && (
                <Button
                  dataTestId="button-ask-again"
                  action={t("expired.ask_another")}
                  onClickAsync={async () => await backToProfile()}
                />
              )}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
